/* app/ui/header/nav.small */

define(
	'app/ui/header/nav.small',[
		'jquery',
		'pubsub'
	],
	function ($) {

		var Module;

		var $menu;
		var selectors;
		var classes;

		var $navItems;
		var $navLinks;
		var elementsInit = false;

		return {
			init: function ($elm, selectorList, classList) {
				Module = this;
				$menu = $elm;
				selectors = selectorList;
				classes = classList;

				Module._initElements();
				Module._initEvents();
			},

			_initElements: function () {
				if (!elementsInit) {
					$navItems = $menu.find(selectors.navItem);
					$navLinks = $menu.find(selectors.navLink);
					elementsInit = true;
				}
			},

			_initEvents: function () {
				$navLinks.on('click', Module._openSubMenu);
			},

			unbind: function () {
				$navLinks.off('click', Module._openSubMenu);
				Module._resetMenu();
			},

			_openSubMenu: function (event) {
				event.preventDefault();

				var $link = $(this);
				var $scope = $link.closest(selectors.nav);
				var $item = $link.closest(selectors.navItem);
				var $childList = $item.closest(selectors.navChildren);

				// Alter scope if we're interacting with a child item
				// Ensure we close open children and not the parent item
				if ($childList.length) {
					$scope = $childList;
				}

				// If the item we're interacting with is being opened, close all it's siblings
				if (!$item.hasClass(classes.expanded)) {
					$scope.find('.' + classes.expanded).removeClass(classes.expanded);
				}

				$item.toggleClass(classes.expanded);
			},

			// Collapse menu and any expanded navigation items
			_resetMenu: function () {
				$.publish('/header/navReset');
				$navItems.removeClass(classes.expanded);
			}
		};
	}
);
